import React from "react";
import { FileText, ArrowRight, ShieldCheck } from "lucide-react";
import { learnerInfo, footer } from "../../content/siteContent";
import { SectionHeading } from "./primitives";
import { Reveal } from "../motion/Reveal";

export const LearnerInfo = () => (
  <section
    id="learner-info"
    data-testid="learner-info-section"
    className="bg-offwhite py-24 lg:py-32 border-t border-hair"
  >
    <div className="container-page">
      <SectionHeading eyebrow={learnerInfo.eyebrow}>{learnerInfo.heading}</SectionHeading>
      <Reveal delay={0.1}>
        <p className="mt-6 text-slate-ink text-base lg:text-lg leading-relaxed max-w-3xl">
          {learnerInfo.intro}
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-8 flex items-start gap-3 rounded-sm border border-teal/30 bg-teal/5 p-5 max-w-3xl">
          <ShieldCheck className="h-5 w-5 text-teal shrink-0 mt-0.5" />
          <p className="text-navy text-sm leading-relaxed">{learnerInfo.fee}</p>
        </div>
      </Reveal>

      <div className="mt-12 grid sm:grid-cols-2 gap-x-10 gap-y-8">
        {learnerInfo.items.map((item, i) => (
          <Reveal key={item.title} delay={(i % 2) * 0.05} className="border-b border-hair pb-6">
            <p className="font-display font-semibold text-navy text-[15px] tracking-tight">{item.title}</p>
            <p className="mt-1.5 text-slate-ink text-sm leading-relaxed">{item.desc}</p>
            {item.link && (
              <a
                href={item.link.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`learner-link-${i}`}
                className="mt-2.5 inline-flex items-center gap-1.5 text-teal text-xs font-display font-semibold hover:underline"
              >
                <FileText className="h-3.5 w-3.5 shrink-0" /> Full detail: {item.link.label}
              </a>
            )}
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <a
          href={footer.contact.studentHandbookUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="learner-handbook-link"
          className="mt-12 inline-flex items-center gap-2 bg-navy text-white font-display font-semibold text-sm rounded-sm px-6 py-3.5 hover:bg-navy/90 transition-colors"
        >
          <FileText className="h-4 w-4" />
          {learnerInfo.handbookCta}
          <ArrowRight className="h-4 w-4" />
        </a>
        <p className="mt-4 text-slate-ink/70 text-xs max-w-3xl">
          You must read Axiom's Policies &amp; Procedures before enrolling. They contain the full fees, refunds,
          cancellation, tuition protection, complaints and appeals, learner support and USI information.
        </p>
        <p className="mt-3 text-slate-ink/70 text-xs max-w-3xl font-medium" data-testid="learner-cricos">
          {learnerInfo.cricos}
        </p>
      </Reveal>
    </div>
  </section>
);
